import { useCallback, useState, useEffect } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GET_COMPANY_INVOICE_INFORMATION_CARD, GET_COMPANY_ADDRESS_FIELD_SETTINGS, GET_COMPANY_INVOICECARD_KNOWN_COMPANIES } from "../../../../../graphql/queries";
import { UPDATE_CREATE_COMPANY_INVOICE_INFORMATION_CARD } from "../../../../../graphql/mutations";
import { cloneDeep } from "lodash";

const createEmptyAddress = () => ({ address1: "", address2: "", address3: "", address4: "", address5: "", city: "", contact: "", country: "", customerId: "", email: "", reference: "", telephone: "", zip: "", });

const useCustomerCardDialogImproved = ({ companyId }) => {
  const [activeStep, setActiveStep] = useState(0);

  // Senast h�mtade/sparade version fr�n servern
  const [fetchedCard, setFetchedCard] = useState({});

  // Anv�ndarens p�g�ende �ndringar
  const [draftCard, setDraftCard] = useState({});

  //Vald kopplad organization (f�r j�mf�reelser)
  const [selectedOrganization, setSelectedOrganization] = useState();

  // Hj�lpfunktion: returnera orgValue endast om currentValue �r "tomt"
  const isEmpty = (value) => value === null || value === undefined || value === '';

  const mergeIfEmpty = (currentValue, orgValue) =>
    isEmpty(currentValue) ? (orgValue ?? currentValue) : currentValue;

  // Sl�r ihop en adress-objekt f�lt-f�r-f�lt
  const mergeAddress = (currentAddress, orgAddress) => {
    if (!orgAddress) return currentAddress;

    const merged = { ...currentAddress };
    Object.keys(orgAddress).forEach((key) => {
      merged[key] = mergeIfEmpty(currentAddress?.[key], orgAddress[key]);
    });
    return merged;
  };

  const updateSelectedOrganization = useCallback((organization) => {
    setSelectedOrganization(organization);

    setDraftCard((currentDraft) => ({
      ...currentDraft,
      reciverCompanyId: organization?.companyId ?? null,

      companyName: mergeIfEmpty(currentDraft.companyName, organization?.name),
      orgNo: mergeIfEmpty(currentDraft.orgNo, organization?.orgNo),
      vatRegNo: mergeIfEmpty(currentDraft.vatRegNo, organization?.vatRegNo),

      invoiceAddress: mergeAddress(currentDraft.invoiceAddress, organization?.invoiceAddress),
      deliveryAddress: mergeAddress(currentDraft.deliveryAddress, organization?.deliveryAddress),
    }));
  }, []);

  
  const [deliverySameAsBilling, setDeliverySameAsBilling] = useState(false);

  const [
    getCompanyInvoiceCard,
    {
      loading: invoiceCardLoading,
      error: invoiceCardError,
    },
  ] = useLazyQuery(GET_COMPANY_INVOICE_INFORMATION_CARD);


  const [
    getCompanyKnownCompanies,
    {
      data: knownCompaniesData,
      loading: knownCompaniesLoading,
      error: knownCompaniesError,
    },
  ] = useLazyQuery(GET_COMPANY_INVOICECARD_KNOWN_COMPANIES);

  const [knownCompanies, setKnownCompanies] = useState([]);

  const fetchKnownCompanies = useCallback(
    async (companyId) => {
      const result = await getCompanyKnownCompanies({
        variables: {
          companyId,
        },
      });

      debugger;
      const companies =
        result?.data?.companyAdminContext?.salesDocuments?.knownCompanies ?? [];

      setKnownCompanies(companies);

      return companies;
    },
    [getCompanyKnownCompanies]
  );

  const [getCompanyAddressFieldSettings, { loading: addressFieldSettingsLoading, error: addressFieldSettingsError, },] = useLazyQuery(GET_COMPANY_ADDRESS_FIELD_SETTINGS);

  const createEmptyCard = useCallback(async (companyId) => {
    const result = await getCompanyAddressFieldSettings({ variables: { companyId, }, });
    const settingsResult = result?.data?.companyAdminContext?.addressSettings?.getCompanyAddressFieldSettings;
    if (!settingsResult?.success) { setDraftCard(null); return null; }

    const emptyCard = {
      id: 0,
      companyId: companyId, companyName: "", comment: "", contact: "",
      contactEmail: "", contactTelephone: "", costPlace1: "",
      costPlace2: "", customerNo: "", distributionType: "EMAIL",
      gLN: "", interest: 0, invoiceEmail: "", invoiceMessage: "",
      isPrivatePerson: false, orgNo: "", ourReference: "",
      yourReference: "", paymentMethod: "INVOICE", paymentTerm: "",
      paymentTermsDays: 30, reciverCompanyId: null, vatRegNo: "", currencyCode: "SEK",

      invoiceAddress: createEmptyAddress(),
      deliveryAddress: createEmptyAddress(),

      invoiceAddressSettings: settingsResult.invoiceAddressSettings,
      deliveryAddressSettings: settingsResult.deliveryAddressSettings,

    }; setDraftCard(emptyCard);

    return emptyCard;

  }, [getCompanyAddressFieldSettings, companyId]);

  const [
    updateCreateInvoiceCard,
    {
      loading: invoiceCardSaving,
      error: invoiceCardSaveError,
    },
  ] = useMutation(UPDATE_CREATE_COMPANY_INVOICE_INFORMATION_CARD);

  const fetchCard = useCallback(
    async (companyId, cardId) => {
      const result = await getCompanyInvoiceCard({
        variables: {
          companyId,
          cardId,
        },
      });

      const cardResult =
        result?.data?.companyAdminContext?.salesDocuments?.getCompanyCard;
      
      if (!cardResult?.success) {
        setFetchedCard(null);
        setDraftCard(null);

        return null;
      }

      const card = cardResult.card;

      setFetchedCard(card);
      setDraftCard(card);

      return card;
    },
    [getCompanyInvoiceCard]
  );

  const updateCard = useCallback((updatedCard) => {
    setDraftCard((currentDraft) => ({
      ...currentDraft,
      ...updatedCard,
    }));
  }, []);

  const updateField = useCallback((field, value) => {
    
    setDraftCard((currentDraft) => ({
      ...currentDraft,
      [field]: value,
    }));
  }, []);

  const onReset = useCallback((field) => {
    setDraftCard((currentDraft) => {
      if (!currentDraft.id || !fetchedCard) {
        // Inget att �terst�lla till - ingen ursprunglig data finns i backend
        return currentDraft;
      }

      return {
        ...currentDraft,
        [field]: fetchedCard[field],
      };
    });
  }, [fetchedCard]);


  const updateAddress = useCallback((addressType, field) => event => {
    const value = event.target.value;

    setDraftCard(currentDraft => ({
      ...currentDraft,
      [addressType]: {
        ...currentDraft[addressType],
        [field]: value,
      },
    }));
  }, []);

  const setAddressFieldValue = useCallback(
    (addressType, fieldKey, value) => {
      setDraftCard(currentDraft => ({
        ...currentDraft,
        [addressType]: {
          ...currentDraft[addressType],
          [fieldKey]: value,
        },
      }));
    },
    []
  );

  const getAddressSettingsKey = addressType => {
    if (addressType === "invoiceAddress") {
      return "invoiceAddressSettings";
    }

    if (addressType === "deliveryAddress") {
      return "deliveryAddressSettings";
    }

    throw new Error(`Unknown address type: ${addressType}`);
  };

  const setAddressFieldSetting = useCallback(
    (addressType, fieldKey, settingKey, value) => {
      const settingsKey = getAddressSettingsKey(addressType);

      setDraftCard(currentDraft => ({
        ...currentDraft,
        [settingsKey]: {
          ...currentDraft[settingsKey],
          [fieldKey]: {
            ...currentDraft[settingsKey]?.[fieldKey],
            [settingKey]: value,
          },
        },
      }));
    },
    []
  );

  const moveAddressLine = useCallback(
    (addressType, draggedKey, targetKey, position = "before") => {
      const settingsKey = getAddressSettingsKey(addressType);

      setDraftCard(currentDraft => {
        const settings = currentDraft[settingsKey];

        if (!settings?.[draggedKey] || !settings?.[targetKey]) {
          return currentDraft;
        }

        const orderedKeys = Object.entries(settings)
          .sort(
            ([, a], [, b]) =>
              Number(a?.displayOrder ?? 0) -
              Number(b?.displayOrder ?? 0)
          )
          .map(([key]) => key);

        const fromIndex = orderedKeys.indexOf(draggedKey);
        const targetIndex = orderedKeys.indexOf(targetKey);

        if (fromIndex < 0 || targetIndex < 0 || fromIndex === targetIndex) {
          return currentDraft;
        }

        orderedKeys.splice(fromIndex, 1);

        const nextTargetIndex = orderedKeys.indexOf(targetKey);

        orderedKeys.splice(
          position === "after"
            ? nextTargetIndex + 1
            : nextTargetIndex,
          0,
          draggedKey
        );

        const nextSettings = { ...settings };

        orderedKeys.forEach((fieldKey, index) => {
          nextSettings[fieldKey] = {
            ...nextSettings[fieldKey],
            displayOrder: index,
          };
        });

        return {
          ...currentDraft,
          [settingsKey]: nextSettings,
        };
      });
    },
    []
  );

  const resetDraft = useCallback(() => {
    if (draftCard?.id === 0) {
      return;
    }

    setDraftCard(fetchedCard);
  }, [draftCard?.id, fetchedCard]);

  const saveCard = useCallback(async () => {
    if (!draftCard) {
      return null;
    }
    
    const input = cloneDeep(draftCard);
        

    Object.values(input.deliveryAddressSettings).forEach((field) => {
      if (field && typeof field === 'object') {
        delete field.placeholder;
      }
    });

    Object.values(input.invoiceAddressSettings).forEach((field) => {
      if (field && typeof field === 'object') {
        delete field.placeholder;
      }
    });

    const result = await updateCreateInvoiceCard({
      variables: {
        input: input,
      },
    });

    const cardResult =
      result?.data?.companyAdminContext?.salesDocuments
        ?.createUpdateCompanyCard;

    if (!cardResult?.success) {
      return null;
    }

    const savedCard = cardResult.card;

    // Serverns version blir nu den nya sanningen
    setFetchedCard(savedCard);

    // Draften synkas med serverns svar
    setDraftCard(savedCard);

    return savedCard;
  }, [draftCard, updateCreateInvoiceCard]);


  useEffect(() => {
    const reciverCompanyId = draftCard?.reciverCompanyId;

    if (!reciverCompanyId) {
      return;
    }

    const flatKnownCompanies = [
      ...(knownCompanies?.knownCompanies ?? []),
      ...(knownCompanies?.publicCompanies ?? []),
      ...(knownCompanies?.supplierCompanies ?? []),
    ];

    if (flatKnownCompanies.length === 0) {
      return;
    }

    if (selectedOrganization?.companyId === reciverCompanyId) {
      return;
    }

    const matchingCompany = flatKnownCompanies.find(
      company => company.companyId === reciverCompanyId
    );

    if (matchingCompany) {
      setSelectedOrganization(matchingCompany);
    }
  }, [draftCard?.reciverCompanyId, knownCompanies, selectedOrganization]);

  const canSave = () => true;

  return {
    activeStep,
    setActiveStep,

    fetchedCard,

    draftCard,

    setFetchedCard,
    setDraftCard,

    createEmptyCard,
    fetchCard,
    fetchKnownCompanies,
    updateCard,
    updateField,
    onReset,
    updateAddress,
    saveCard,
    resetDraft,

    canSave,    

    knownCompanies,
    knownCompaniesLoading,
    knownCompaniesError,

    selectedOrganization,
    updateSelectedOrganization,

    getAddressSettingsKey,
    setAddressFieldValue,
    setAddressFieldSetting,
    moveAddressLine,
    setDeliverySameAsBilling,

    invoiceCardLoading,
    invoiceCardError,

    invoiceCardSaving,
    invoiceCardSaveError,
  };
};

export default useCustomerCardDialogImproved;